import React from 'react';

const RemoveConfirmationModal = ({ onClose, onConfirm, itemName }) => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}
  >
    <div
      style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        width: '400px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      }}
    >
      <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
        Confirm Removal
      </h3>
      <p style={{ color: '#666', marginBottom: '20px' }}>
        Are you sure you want to remove {itemName}?
      </p>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
        <button
          onClick={onClose}
          style={{
            padding: '8px 16px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            background: 'white',
            color: '#333',
            cursor: 'pointer',
            fontSize: '14px',
          }}
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          style={{
            padding: '8px 16px',
            border: 'none',
            borderRadius: '4px',
            backgroundColor: '#FF4D4F',
            color: 'white',
            cursor: 'pointer',
            fontSize: '14px',
          }}
        >
          Remove
        </button>
      </div>
    </div>
  </div>
);

export default RemoveConfirmationModal;